import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\WebhooksController::index
* @see app/Http/Controllers/Admin/WebhooksController.php:26
* @route '/admin/webhooks'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/webhooks',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::index
* @see app/Http/Controllers/Admin/WebhooksController.php:26
* @route '/admin/webhooks'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::index
* @see app/Http/Controllers/Admin/WebhooksController.php:26
* @route '/admin/webhooks'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::index
* @see app/Http/Controllers/Admin/WebhooksController.php:26
* @route '/admin/webhooks'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::index
* @see app/Http/Controllers/Admin/WebhooksController.php:26
* @route '/admin/webhooks'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::index
* @see app/Http/Controllers/Admin/WebhooksController.php:26
* @route '/admin/webhooks'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::index
* @see app/Http/Controllers/Admin/WebhooksController.php:26
* @route '/admin/webhooks'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::create
* @see app/Http/Controllers/Admin/WebhooksController.php:46
* @route '/admin/webhooks/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/webhooks/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::create
* @see app/Http/Controllers/Admin/WebhooksController.php:46
* @route '/admin/webhooks/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::create
* @see app/Http/Controllers/Admin/WebhooksController.php:46
* @route '/admin/webhooks/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::create
* @see app/Http/Controllers/Admin/WebhooksController.php:46
* @route '/admin/webhooks/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::create
* @see app/Http/Controllers/Admin/WebhooksController.php:46
* @route '/admin/webhooks/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::create
* @see app/Http/Controllers/Admin/WebhooksController.php:46
* @route '/admin/webhooks/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::create
* @see app/Http/Controllers/Admin/WebhooksController.php:46
* @route '/admin/webhooks/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::store
* @see app/Http/Controllers/Admin/WebhooksController.php:58
* @route '/admin/webhooks'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/webhooks',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::store
* @see app/Http/Controllers/Admin/WebhooksController.php:58
* @route '/admin/webhooks'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::store
* @see app/Http/Controllers/Admin/WebhooksController.php:58
* @route '/admin/webhooks'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::store
* @see app/Http/Controllers/Admin/WebhooksController.php:58
* @route '/admin/webhooks'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::store
* @see app/Http/Controllers/Admin/WebhooksController.php:58
* @route '/admin/webhooks'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::show
* @see app/Http/Controllers/Admin/WebhooksController.php:77
* @route '/admin/webhooks/{endpoint}'
*/
export const show = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/webhooks/{endpoint}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::show
* @see app/Http/Controllers/Admin/WebhooksController.php:77
* @route '/admin/webhooks/{endpoint}'
*/
show.url = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { endpoint: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { endpoint: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            endpoint: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        endpoint: typeof args.endpoint === 'object'
        ? args.endpoint.id
        : args.endpoint,
    }

    return show.definition.url
            .replace('{endpoint}', parsedArgs.endpoint.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::show
* @see app/Http/Controllers/Admin/WebhooksController.php:77
* @route '/admin/webhooks/{endpoint}'
*/
show.get = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::show
* @see app/Http/Controllers/Admin/WebhooksController.php:77
* @route '/admin/webhooks/{endpoint}'
*/
show.head = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::show
* @see app/Http/Controllers/Admin/WebhooksController.php:77
* @route '/admin/webhooks/{endpoint}'
*/
const showForm = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::show
* @see app/Http/Controllers/Admin/WebhooksController.php:77
* @route '/admin/webhooks/{endpoint}'
*/
showForm.get = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::show
* @see app/Http/Controllers/Admin/WebhooksController.php:77
* @route '/admin/webhooks/{endpoint}'
*/
showForm.head = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::update
* @see app/Http/Controllers/Admin/WebhooksController.php:101
* @route '/admin/webhooks/{endpoint}'
*/
export const update = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/admin/webhooks/{endpoint}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::update
* @see app/Http/Controllers/Admin/WebhooksController.php:101
* @route '/admin/webhooks/{endpoint}'
*/
update.url = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { endpoint: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { endpoint: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            endpoint: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        endpoint: typeof args.endpoint === 'object'
        ? args.endpoint.id
        : args.endpoint,
    }

    return update.definition.url
            .replace('{endpoint}', parsedArgs.endpoint.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::update
* @see app/Http/Controllers/Admin/WebhooksController.php:101
* @route '/admin/webhooks/{endpoint}'
*/
update.put = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::update
* @see app/Http/Controllers/Admin/WebhooksController.php:101
* @route '/admin/webhooks/{endpoint}'
*/
const updateForm = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::update
* @see app/Http/Controllers/Admin/WebhooksController.php:101
* @route '/admin/webhooks/{endpoint}'
*/
updateForm.put = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::destroy
* @see app/Http/Controllers/Admin/WebhooksController.php:120
* @route '/admin/webhooks/{endpoint}'
*/
export const destroy = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/admin/webhooks/{endpoint}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::destroy
* @see app/Http/Controllers/Admin/WebhooksController.php:120
* @route '/admin/webhooks/{endpoint}'
*/
destroy.url = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { endpoint: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { endpoint: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            endpoint: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        endpoint: typeof args.endpoint === 'object'
        ? args.endpoint.id
        : args.endpoint,
    }

    return destroy.definition.url
            .replace('{endpoint}', parsedArgs.endpoint.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::destroy
* @see app/Http/Controllers/Admin/WebhooksController.php:120
* @route '/admin/webhooks/{endpoint}'
*/
destroy.delete = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::destroy
* @see app/Http/Controllers/Admin/WebhooksController.php:120
* @route '/admin/webhooks/{endpoint}'
*/
const destroyForm = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::destroy
* @see app/Http/Controllers/Admin/WebhooksController.php:120
* @route '/admin/webhooks/{endpoint}'
*/
destroyForm.delete = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::toggle
* @see app/Http/Controllers/Admin/WebhooksController.php:131
* @route '/admin/webhooks/{endpoint}/toggle'
*/
export const toggle = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggle.url(args, options),
    method: 'post',
})

toggle.definition = {
    methods: ["post"],
    url: '/admin/webhooks/{endpoint}/toggle',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::toggle
* @see app/Http/Controllers/Admin/WebhooksController.php:131
* @route '/admin/webhooks/{endpoint}/toggle'
*/
toggle.url = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { endpoint: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { endpoint: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            endpoint: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        endpoint: typeof args.endpoint === 'object'
        ? args.endpoint.id
        : args.endpoint,
    }

    return toggle.definition.url
            .replace('{endpoint}', parsedArgs.endpoint.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::toggle
* @see app/Http/Controllers/Admin/WebhooksController.php:131
* @route '/admin/webhooks/{endpoint}/toggle'
*/
toggle.post = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggle.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::toggle
* @see app/Http/Controllers/Admin/WebhooksController.php:131
* @route '/admin/webhooks/{endpoint}/toggle'
*/
const toggleForm = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggle.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::toggle
* @see app/Http/Controllers/Admin/WebhooksController.php:131
* @route '/admin/webhooks/{endpoint}/toggle'
*/
toggleForm.post = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggle.url(args, options),
    method: 'post',
})

toggle.form = toggleForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::regenerateSecret
* @see app/Http/Controllers/Admin/WebhooksController.php:146
* @route '/admin/webhooks/{endpoint}/regenerate-secret'
*/
export const regenerateSecret = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: regenerateSecret.url(args, options),
    method: 'post',
})

regenerateSecret.definition = {
    methods: ["post"],
    url: '/admin/webhooks/{endpoint}/regenerate-secret',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::regenerateSecret
* @see app/Http/Controllers/Admin/WebhooksController.php:146
* @route '/admin/webhooks/{endpoint}/regenerate-secret'
*/
regenerateSecret.url = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { endpoint: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { endpoint: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            endpoint: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        endpoint: typeof args.endpoint === 'object'
        ? args.endpoint.id
        : args.endpoint,
    }

    return regenerateSecret.definition.url
            .replace('{endpoint}', parsedArgs.endpoint.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::regenerateSecret
* @see app/Http/Controllers/Admin/WebhooksController.php:146
* @route '/admin/webhooks/{endpoint}/regenerate-secret'
*/
regenerateSecret.post = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: regenerateSecret.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::regenerateSecret
* @see app/Http/Controllers/Admin/WebhooksController.php:146
* @route '/admin/webhooks/{endpoint}/regenerate-secret'
*/
const regenerateSecretForm = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: regenerateSecret.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::regenerateSecret
* @see app/Http/Controllers/Admin/WebhooksController.php:146
* @route '/admin/webhooks/{endpoint}/regenerate-secret'
*/
regenerateSecretForm.post = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: regenerateSecret.url(args, options),
    method: 'post',
})

regenerateSecret.form = regenerateSecretForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::test
* @see app/Http/Controllers/Admin/WebhooksController.php:160
* @route '/admin/webhooks/{endpoint}/test'
*/
export const test = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: test.url(args, options),
    method: 'post',
})

test.definition = {
    methods: ["post"],
    url: '/admin/webhooks/{endpoint}/test',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::test
* @see app/Http/Controllers/Admin/WebhooksController.php:160
* @route '/admin/webhooks/{endpoint}/test'
*/
test.url = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { endpoint: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { endpoint: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            endpoint: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        endpoint: typeof args.endpoint === 'object'
        ? args.endpoint.id
        : args.endpoint,
    }

    return test.definition.url
            .replace('{endpoint}', parsedArgs.endpoint.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::test
* @see app/Http/Controllers/Admin/WebhooksController.php:160
* @route '/admin/webhooks/{endpoint}/test'
*/
test.post = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: test.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::test
* @see app/Http/Controllers/Admin/WebhooksController.php:160
* @route '/admin/webhooks/{endpoint}/test'
*/
const testForm = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: test.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::test
* @see app/Http/Controllers/Admin/WebhooksController.php:160
* @route '/admin/webhooks/{endpoint}/test'
*/
testForm.post = (args: { endpoint: string | { id: string } } | [endpoint: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: test.url(args, options),
    method: 'post',
})

test.form = testForm

/**
* @see \App\Http\Controllers\Admin\WebhooksController::replay
* @see app/Http/Controllers/Admin/WebhooksController.php:177
* @route '/admin/webhooks/{endpoint}/deliveries/{delivery}/replay'
*/
export const replay = (args: { endpoint: string | { id: string }, delivery: string | { id: string } } | [endpoint: string | { id: string }, delivery: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

replay.definition = {
    methods: ["post"],
    url: '/admin/webhooks/{endpoint}/deliveries/{delivery}/replay',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\WebhooksController::replay
* @see app/Http/Controllers/Admin/WebhooksController.php:177
* @route '/admin/webhooks/{endpoint}/deliveries/{delivery}/replay'
*/
replay.url = (args: { endpoint: string | { id: string }, delivery: string | { id: string } } | [endpoint: string | { id: string }, delivery: string | { id: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            endpoint: args[0],
            delivery: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        endpoint: typeof args.endpoint === 'object'
        ? args.endpoint.id
        : args.endpoint,
        delivery: typeof args.delivery === 'object'
        ? args.delivery.id
        : args.delivery,
    }

    return replay.definition.url
            .replace('{endpoint}', parsedArgs.endpoint.toString())
            .replace('{delivery}', parsedArgs.delivery.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\WebhooksController::replay
* @see app/Http/Controllers/Admin/WebhooksController.php:177
* @route '/admin/webhooks/{endpoint}/deliveries/{delivery}/replay'
*/
replay.post = (args: { endpoint: string | { id: string }, delivery: string | { id: string } } | [endpoint: string | { id: string }, delivery: string | { id: string } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::replay
* @see app/Http/Controllers/Admin/WebhooksController.php:177
* @route '/admin/webhooks/{endpoint}/deliveries/{delivery}/replay'
*/
const replayForm = (args: { endpoint: string | { id: string }, delivery: string | { id: string } } | [endpoint: string | { id: string }, delivery: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\WebhooksController::replay
* @see app/Http/Controllers/Admin/WebhooksController.php:177
* @route '/admin/webhooks/{endpoint}/deliveries/{delivery}/replay'
*/
replayForm.post = (args: { endpoint: string | { id: string }, delivery: string | { id: string } } | [endpoint: string | { id: string }, delivery: string | { id: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: replay.url(args, options),
    method: 'post',
})

replay.form = replayForm

const webhooks = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    toggle: Object.assign(toggle, toggle),
    regenerateSecret: Object.assign(regenerateSecret, regenerateSecret),
    test: Object.assign(test, test),
    replay: Object.assign(replay, replay),
}

export default webhooks